import styled from '@emotion/styled';
import theme from 'utils/theme';

export const TextContentForm = styled.div`
  color: #E5E5E5;
  font-family: Open Sans;
  font-size: ${theme.typography.large24};
  font-style: normal;
  font-weight: 600;
  line-height: ${theme.typography.large45};

  @media screen and (max-width: ${(props) =>
    props?.theme?.breakpoints.largeTablet}px) {
    max-width: 100%;
    font-size: ${theme.typography.large20};
  }
`;

export const ButtonStartAdventure = styled.button`
  border-radius: 16px;
  height: 56px;
  max-width: 450px;
  min-width: 250px;
  background-color: #f5c05d;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 5px 20px;
  margin: 20px 0;
  align-self: center;

  &:hover {
    background-color: #ad760e;
    color: #ffee10;
    box-shadow: 0 0 5px #ffee10;
    text-shadow: 0 0 5px #ffee10;
    transition: 0.5s;
    transform: scale(1.02);
    cursor: pointer;
  }
`;

export const LabelButtonStartAdventure = styled.div`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  line-height: ${theme.typography.large32};
  font-size: ${theme.typography.large24};
`;

export const FooterNga = styled.div`  
  color: #ADADAD;
  font-family: Open Sans;
  font-size: ${theme.typography.large16};
  font-style: normal;
  font-weight: 400;
  line-height: 36px;   
`;

// CONTAINER
export const ContainerLanding = styled.div`
  display: flex;
  align-items: center;
  background-color: ${theme.colors.background};
  flex-direction: column;
  padding: 1em 0;
  height: 100%;
  width: 100%;

  @media screen and (max-width: ${theme.breakpoints.phablet}px) {
    flex: 1;
    padding: 0;    
    background-color: ${theme.colors.blue1};
  }
`

export const ContainterLandingCenter = styled(ContainerLanding)`
  justify-content: center;
`

export const TextContentWrapper = styled.div`  
  flex: 1;
  padding: 1em 3em;
  justify-content: center;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${theme.breakpoints.phablet}px) {
    padding: 0 1em;
  }
`

// TITLE
export const TextTitle = styled.div`
  color: #FFF;
  text-align: center;
  font-family: Open Sans;  
  font-style: normal;
  font-weight: 600;
  line-height: ${theme.typography.large60};
  font-size: ${theme.typography.large45};

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.largeTablet}px) {
    font-style: normal;
    font-weight: 600;
  }

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.mobile}px) {
    font-size: ${theme.typography.large22};
    line-height: ${theme.typography.large32};
    text-align: left;
  }
`;

export const TextContent = styled.div`
  color: #E5E5E5;
  font-family: Open Sans;
  font-size: ${theme.typography.large24};
  font-style: normal;
  font-weight: 600;

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.largeTablet}px) {
    max-width: 100%;
  }

  @media screen and (max-width: ${(props) => props?.theme?.breakpoints.mobile}px) {
    font-size: ${theme.typography.large20};
    line-height: ${theme.typography.large28};    
    text-align: left;    
  }
`;
